import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { TabData } from "sr/i18n/messages/setting";
interface propsType {
    HandleActiveTab: (value: string) => void;
    activeTab: string;
    tabCount?: Record<string, number>; 
  isAllowedPreOnBordingSubmission?: boolean;
}
export const ApplicationTab = (props:propsType) => {
  const [Checkbtn, setCheckbtn] = useState("");
  const isFirstRender = useRef(true);
  const [isDragging, setisDragging] = useState(false);
  const [prevTouchX, setprevTouchX] = useState();
  const refs = useRef(null);
  const tabs = props.isAllowedPreOnBordingSubmission
    ? TabData.flatMap((tab) =>
        tab.value === "hired"
          ? [
              {
                tabname: (
                  <FormattedMessage
                    id="RECRUITER.CANDIDATES.FILTERS.PREONBOARDING"
                    defaultMessage="Pre-Onboarding"
                  />
                ),
                value: "preonboarding",
              },
              tab,
            ]
          : [tab],
      )
    : TabData;
  useEffect(() => {
   if (isFirstRender.current) {
       isFirstRender.current = false;
       return; // Skip the effect on the initial render
   }

   refs.current.scrollLeft += Checkbtn === "left" ? -350 : 350;
}, [Checkbtn]);
  return (
    <div className='flex-1 flex space-x-8 justify-center'>
    <svg onClick={() => setCheckbtn("left")} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
     className="w-6 h-6 cursor-pointer lg:hidden xl:hidden">
     <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
   </svg>
   <div  ref={refs} className='flex-1 flex space-x-10 overflow-hidden'>
    { tabs?.map((data, index)=> (
       <span key={index} onClick={()=> props?.HandleActiveTab(data.value)} className={`${props?.activeTab === data.value ? "text-[#0078ae] border-b-2 border-[#0078ae] font-bold":""} hover:text-[#0078ae]  text-base inline-flex flex-shrink-0 cursor-pointer pb-1`}>{data.tabname} ({(props?.tabCount && props?.tabCount[data.value]) ||0})</span>
       )) }
   </div>
   <svg onClick={() => setCheckbtn("right")} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
    className="w-6 h-6 cursor-pointer lg:hidden xl:hidden">
     <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
   </svg>
   
    </div>
  );
};
